module.exports = __webpack_public_path__ + "img/shopbanner.23328807.png";